import { render } from "./index.vue?vue&type=template&id=944088a2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=944088a2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-944088a2"],['__file',"src/components/PageHeader/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "944088a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('944088a2', __exports__)) {
    api.reload('944088a2', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=944088a2&scoped=true", () => {
    api.rerender('944088a2', render)
  })

}


export default __exports__